import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { global } from 'app/utils/global';
import { LocalStorageService } from '../local-storage.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../local-storage.service";
var AuthService = /** @class */ (function () {
    function AuthService(httpClient, localStorageService, localStorage) {
        this.httpClient = httpClient;
        this.localStorageService = localStorageService;
        this.localStorage = localStorage;
        this.httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        this.url = environment.URL_SICO + 'usuario/';
    }
    AuthService.prototype.getUsuario = function () {
        var usuario = this.localStorage.get(global.SESSION_ITEMS.USU_SESION);
        return usuario;
    };
    AuthService.prototype.getRol = function () {
        var usuario = this.localStorage.get(global.SESSION_ITEMS.USU_SESION);
        return usuario.nombreRol;
    };
    AuthService.prototype.logisticaReversiva = function () {
        var exist = this.localStorageService.get(global.SESSION_ITEMS.LOGISTICA_REVERSIVA.CARRITO);
        if (exist) {
            return true;
        }
        else {
            return false;
        }
    };
    AuthService.prototype.garantia = function () {
        var exist = this.localStorageService.get(global.SESSION_ITEMS.GARANTIA.CARRITO);
        if (exist) {
            return true;
        }
        else {
            return false;
        }
    };
    AuthService.prototype.rotacion = function () {
        var exist = this.localStorageService.get(global.SESSION_ITEMS.ROTACION.CARRITO);
        if (exist) {
            return true;
        }
        else {
            return false;
        }
    };
    AuthService.prototype.recaudo = function () {
        var exist = this.localStorageService.get(global.SESSION_ITEMS.RECAUDO.CARRITO);
        if (exist) {
            return true;
        }
        else {
            return false;
        }
    };
    AuthService.prototype.menuDerecho = function () {
        var exist = this.localStorageService.get(global.SESSION_ITEMS.MENU_DERECHO);
        if (exist) {
            return true;
        }
        else {
            return false;
        }
    };
    AuthService.prototype.tomarPedido = function () {
        var exist = this.localStorageService.get(global.SESSION_ITEMS.PEDIDO.CARRITO);
        if (exist) {
            return true;
        }
        else {
            return false;
        }
    };
    AuthService.prototype.cliente = function () {
        var exist = this.localStorageService.get(global.SESSION_ITEMS.CLIENTE);
        if (exist !== null) {
            return true;
        }
        else {
            return false;
        }
    };
    AuthService.ngInjectableDef = i0.defineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.inject(i1.HttpClient), i0.inject(i2.LocalStorageService), i0.inject(i2.LocalStorageService)); }, token: AuthService, providedIn: "root" });
    return AuthService;
}());
export { AuthService };
